import React, { useEffect, useRef, useState, useContext } from 'react';
import { LoadingContext } from '../contexts/LoadingContext';
import AxelLogo from './Header/AxelLogo';
import '../styles/Loading.scss';

const Loading = () => {
  const [fadeOut, setFadeOut] = useState(false);
  const { isFirstLoad, setIsFirstLoad, setSplashFading } = useContext(LoadingContext);
  // URL stable -> mise en cache navigateur. Nouveau nom de fichier = nouvelle
  // version (1280p, ~0,6 Mo au lieu de 7,3 Mo), le poster JPEG sert de LCP.
  const videoSrc = useRef('/loading-720.mp4');

  useEffect(() => {
    if (!isFirstLoad) return;
    // L'app shell statique de index.html (#splash-static, même rendu que cet
    // overlay) a fait le premier paint ; maintenant que l'overlay React est
    // monté par-dessus, on le retire.
    document.getElementById('splash-static')?.remove();
    const safetyTimer = setTimeout(triggerFadeOut, 8500);
    return () => clearTimeout(safetyTimer);
  }, [isFirstLoad]);

  const triggerFadeOut = () => {
    setFadeOut(true);
    setSplashFading(true); // l'app redevient visible sous le fondu
    setTimeout(() => setIsFirstLoad(false), 600);
  };

  if (!isFirstLoad) return null;

  return (
    <div className={`loading-container ${fadeOut ? 'fade-out' : ''}`}>
      <div className="loading-video-div">
        <video
          className="loading-video"
          src={videoSrc.current}
          poster="/loading-poster.jpg"
          autoPlay
          muted
          playsInline
          preload="auto"
          onEnded={triggerFadeOut}
        />
      </div>
      <div className="loading-text-div">
        <p className="loading-name">
          Axel Grégoire <span>is coming</span>
        </p>
        <div className="loading-logo-mobile" aria-hidden="true">
          <AxelLogo
            size={84}
            smallDotSize={3}
            bigDotSize={5}
            invertLogo
            spin
          />
        </div>
      </div>
    </div>
  );
};

export default Loading;
